import { Briefcase } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getStatusBadge } from '@/lib/statusConfig';
import { nextAction } from '@/lib/dashboardActions';
import { formatDate } from '@/lib/formatters';
import Panel from './Panel';

const serviceLabel = (job) => (job.serviceType === 'diy' ? 'DIY with AI' : 'Expert Help');

const RecentJobsTable = ({ jobs, loading, onNavigate }) => (
  <Panel title="Recent Jobs" onViewAll={() => onNavigate('/jobs')} testId="recent-jobs">
    {!loading && jobs.length === 0 ? (
      <div className="text-center py-8" data-testid="empty-jobs">
        <Briefcase className="w-8 h-8 mx-auto mb-3 text-muted-foreground" />
        <p className="text-sm text-muted-foreground mb-4">No jobs yet</p>
        <Button size="sm" onClick={() => onNavigate('/wizard/start')}>Create Your First Job</Button>
      </div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs font-medium tracking-wider uppercase text-muted-foreground border-b border-border">
              <th className="py-2 pr-4">Job ID</th>
              <th className="py-2 pr-4">Company</th>
              <th className="py-2 pr-4">Service</th>
              <th className="py-2 pr-4">Status</th>
              <th className="py-2 pr-4">Last Updated</th>
              <th className="py-2">Next Action</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job) => {
              const action = nextAction(job);
              return (
                <tr key={job.id} className="table-row border-b border-border last:border-0" data-testid={`job-row-${job.jobId}`}>
                  <td className="py-3 pr-4 font-mono">{job.jobId}</td>
                  <td className="py-3 pr-4">{job.companyName}</td>
                  <td className="py-3 pr-4 text-muted-foreground">{serviceLabel(job)}</td>
                  <td className="py-3 pr-4">{getStatusBadge(job.status)}</td>
                  <td className="py-3 pr-4 text-muted-foreground whitespace-nowrap">{formatDate(job.date || job.createdAt)}</td>
                  <td className="py-3">
                    <Button size="sm" variant={action.primary ? 'default' : 'outline'} onClick={() => onNavigate(action.to)}>
                      {action.label}
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
  </Panel>
);

export default RecentJobsTable;
